import { render, staticRenderFns } from "./OaoNotification.vue?vue&type=template&id=7595b79c&scoped=true&functional=true"
import script from "./OaoNotification.vue?vue&type=script&lang=js"
export * from "./OaoNotification.vue?vue&type=script&lang=js"
import style0 from "./OaoNotification.vue?vue&type=style&index=0&id=7595b79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7595b79c",
  null
  
)

export default component.exports